import React from 'react';

import Layout from 'layouts/Layout';
import DaysOff from './DaysOff';

const DaysOffLayout = ({ match }) => <Layout component={DaysOff} match={match} />;

export default DaysOffLayout;
